export const landingTranslations = {
  fr: {
    nav_download: 'Télécharger',
    nav_features: 'Fonctionnalités',
    nav_how: 'Comment ça marche',
    nav_contact: 'Contact',
    hero_badge: 'Application mobile · Tunisie',
    hero_title_lead: 'Votre déménagement, ',
    hero_title_highlight: 'simplifié',
    hero_subtitle:
      'Liberty connecte clients et déménageurs professionnels. Réservez, négociez, suivez votre mission et communiquez — le tout depuis votre téléphone.',
    hero_cta: 'Télécharger l’application',
    store_app_store: 'App Store',
    store_google_play: 'Google Play',
    store_coming_soon: 'Bientôt disponible',
    section_app_title: 'Une application, tous vos besoins de transport',
    section_app_subtitle:
      'Que vous déménagiez, transportiez un colis ou gériez vos missions, Liberty centralise tout dans une seule app.',
    feature_find_title: 'Trouver un déménageur',
    feature_find_desc: 'Parcourez les transporteurs disponibles près de chez vous et lancez une demande en quelques minutes.',
    feature_price_title: 'Prix transparent',
    feature_price_desc: 'Proposez un budget ou négociez avec le déménageur jusqu’à trouver un accord équitable.',
    feature_track_title: 'Suivi en direct',
    feature_track_desc: 'Suivez le camion sur la carte et recevez des mises à jour en temps réel sur votre mission.',
    feature_chat_title: 'Chat & appels',
    feature_chat_desc: 'Échangez par message ou appelez directement depuis l’application, sans partager votre numéro.',
    feature_quick_title: 'Transport rapide',
    feature_quick_desc: 'Envoyez un article ou un colis urgent sans organiser un déménagement complet.',
    feature_intl_title: 'Transport international',
    feature_intl_desc: 'Organisez des missions transfrontalières avec suivi et validation par QR code.',
    audience_clients_title: 'Pour les clients',
    audience_clients_desc: 'Demandez un service, comparez les offres, suivez votre mission et évaluez votre déménageur.',
    audience_clients_1: 'Réservation simple',
    audience_clients_2: 'Suivi GPS',
    audience_clients_3: 'Support intégré',
    audience_movers_title: 'Pour les déménageurs',
    audience_movers_desc: 'Recevez des missions, gérez votre activité et développez votre clientèle depuis l’app.',
    audience_movers_1: 'Missions en temps réel',
    audience_movers_2: 'Statistiques & abonnements',
    audience_movers_3: 'Chat avec les clients',
    how_title: 'Comment ça marche',
    how_subtitle: 'Trois étapes pour commencer avec Liberty',
    how_step1_title: 'Téléchargez l’app',
    how_step1_desc: 'Installez Liberty sur iPhone ou Android.',
    how_step2_title: 'Créez votre compte',
    how_step2_desc: 'Choisissez votre profil : client ou déménageur.',
    how_step3_title: 'Lancez votre mission',
    how_step3_desc: 'Réservez un service ou acceptez une mission — Liberty s’occupe du reste.',
    download_title: 'Prêt à commencer ?',
    download_subtitle: 'Téléchargez Liberty et gérez vos déménagements où que vous soyez.',
    trust_title: 'Sécurité & confiance',
    trust_desc:
      'Profils vérifiés, évaluations après chaque mission et assistance disponible. Votre tranquillité d’esprit, notre priorité.',
    footer_tagline: 'La mobilité et le déménagement, réinventés en Tunisie.',
    footer_contact: 'Contact',
    footer_follow: 'Suivez-nous',
    footer_rights: 'Tous droits réservés.',
    lang_fr: 'Français',
    lang_ar: 'العربية',
  },
  ar: {
    nav_download: 'تحميل',
    nav_features: 'الميزات',
    nav_how: 'كيف يعمل',
    nav_contact: 'اتصل بنا',
    hero_badge: 'تطبيق جوال · تونس',
    hero_title_lead: 'انتقالك، بكل ',
    hero_title_highlight: 'بساطة',
    hero_subtitle:
      'Liberty يربط العملاء بناقلين محترفين. احجز، تفاوض، تابع مهمتك وتواصل — كل ذلك من هاتفك.',
    hero_cta: 'حمّل التطبيق',
    store_app_store: 'App Store',
    store_google_play: 'Google Play',
    store_coming_soon: 'قريباً',
    section_app_title: 'تطبيق واحد لكل احتياجات النقل',
    section_app_subtitle:
      'سواء كنت تنتقل أو تنقل طرداً أو تدير مهامك، Liberty يجمع كل شيء في تطبيق واحد.',
    feature_find_title: 'ابحث عن ناقل',
    feature_find_desc: 'اعثر على الناقلين المتاحين قربك واطلب خدمة في دقائق.',
    feature_price_title: 'أسعار شفافة',
    feature_price_desc: 'اقترح ميزانيتك أو تفاوض مع الناقل حتى تصل إلى اتفاق عادل.',
    feature_track_title: 'تتبع مباشر',
    feature_track_desc: 'تابع الشاحنة على الخريطة واحصل على تحديثات فورية لمهمتك.',
    feature_chat_title: 'دردشة ومكالمات',
    feature_chat_desc: 'تواصل برسائل أو اتصل مباشرة من التطبيق دون مشاركة رقمك.',
    feature_quick_title: 'نقل سريع',
    feature_quick_desc: 'أرسل غرضاً أو طرداً عاجلاً دون تنظيم انتقال كامل.',
    feature_intl_title: 'نقل دولي',
    feature_intl_desc: 'نظّم مهاماً عبر الحدود مع تتبع وتأكيد عبر رمز QR.',
    audience_clients_title: 'للعملاء',
    audience_clients_desc: 'اطلب خدمة، قارن العروض، تابع مهمتك وقيّم الناقل.',
    audience_clients_1: 'حجز بسيط',
    audience_clients_2: 'تتبع GPS',
    audience_clients_3: 'دعم مدمج',
    audience_movers_title: 'للناقلين',
    audience_movers_desc: 'استقبل المهام، أدر نشاطك ووسّع قاعدة عملائك من التطبيق.',
    audience_movers_1: 'مهام فورية',
    audience_movers_2: 'إحصائيات واشتراكات',
    audience_movers_3: 'دردشة مع العملاء',
    how_title: 'كيف يعمل',
    how_subtitle: 'ثلاث خطوات للبدء مع Liberty',
    how_step1_title: 'حمّل التطبيق',
    how_step1_desc: 'ثبّت Liberty على iPhone أو Android.',
    how_step2_title: 'أنشئ حسابك',
    how_step2_desc: 'اختر ملفك: عميل أو ناقل.',
    how_step3_title: 'ابدأ مهمتك',
    how_step3_desc: 'احجز خدمة أو اقبل مهمة — Liberty يتولى الباقي.',
    download_title: 'مستعد للبدء؟',
    download_subtitle: 'حمّل Liberty وأدر انتقالاتك أينما كنت.',
    trust_title: 'الأمان والثقة',
    trust_desc:
      'ملفات موثّقة، تقييمات بعد كل مهمة ومساعدة متاحة. راحتك أولويتنا.',
    footer_tagline: 'التنقل والانتقال، بإعادة ابتكار في تونس.',
    footer_contact: 'اتصل بنا',
    footer_follow: 'تابعنا',
    footer_rights: 'جميع الحقوق محفوظة.',
    lang_fr: 'Français',
    lang_ar: 'العربية',
  },
};

export function getLandingText(language) {
  return landingTranslations[language === 'ar' ? 'ar' : 'fr'];
}
